import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { adsBulkEdit } from '@bingads-webui-campaign/ads-bulk-edit';
import { aggregatedRowsPluginBuilder } from '@bingads-webui-campaign/pgrid-aggregated-rows';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { automatedRulesPlugin } from '@bingads-webui-campaign/projection-grid-automated-rules';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { inlineDownloadWithoutFilterstatePlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { jsdataRawDataPlugin as commonJsdataRawDataPlugin } from '@bingads-webui/projection-grid-js-data-raw-data';
import { labelsPlugin } from '@bingads-webui-campaign/projection-grid-labels';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { performanceLogPlugin, perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { periodOverPeriodPlugin } from '@bingads-webui-campaign/projection-grid-period-over-period';
import { segmentPlugin } from '@bingads-webui-campaign/projection-grid-segment';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { Ad, Label } from '@bingads-webui-campaign/campaign-ui-schemas';
import { getPGridColumnResizePlugin } from '@bingads-webui-campaign/projection-grid-column-resize-helper';
import { projectionGridFlexColumnResize } from '@bingads-webui-campaign/projection-grid-flex-column-resize';
import { getGridName } from '@bingads-webui-campaign/inline-download-grids-metadata';

import { mockEdm } from '../demo/mock/edm';
import { getColumnChooserConfig } from './columns/index';
import adsStatus from './ads-status';

const appState = globalContext.require('component/state/index');
const edm = globalContext.requireDefault('component/edm-campaign/index');
const appConfig = globalContext.require('component/config/index');
const { setSegType, getSegType } = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const { DownloadView } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const i18nErrors = globalContext.require('component/api-errors-campaign/index');
const jsdata = globalContext.require('component/js-data-campaign/index');
const { LabelAssociationView } = globalContext.require('campaignui/feature/common-grid-plugins/label/label-association-view');
const dataContextManager = globalContext.require('SummaryDataContextManager');
const cacheService = globalContext.require('Services/CacheService');
const instrumentation = globalContext.requireDefault('campaignui/feature/instrumentation/index');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/ads-tab');
const s$i18n = globalContext.require('$/schema-i18n!campaign');
const logger = globalContext.require('module/service/instrumentation/index');
const ChangeStatusView = globalContext.require('module/view/bulkEdit/ad/changeStatus');
const ChangeStatusModel = globalContext.require('module/model/bulkEdit/ad/changeStatus');
const ChangeAdsView = globalContext.require('module/view/bulkEdit/ad/changeTextAd');
const ChangeAdsModel = globalContext.require('module/model/bulkEdit/ad/changeTextAd');
const ChangeThirdPartyMeasurementView = globalContext.require('module/view/bulkEdit/ad/changeThirdPartyMeasurement');
const ChangeThirdPartyMeasurementModel = globalContext.require('module/model/bulkEdit/ad/changeThirdPartyMeasurement');
const ChangeThirdPartyMeasurementViewV2 = globalContext.require('module/view/bulkEdit/ad/changeThirdPartyMeasurementV2');
const ChangeUrlOptionsModel = globalContext.require('module/model/bulkEdit/shared/changeUrlOptions');
const ChangeUrlOptionsView = globalContext.require('module/view/bulkEdit/shared/changeUrlOptions');
const CopyPaste = globalContext.require('module/view/bulkEdit/copyPaste');
const odata = globalContext.require('module/service/communication/channel/odata');
const stateManager = globalContext.require('StateManager/CampaignStateManager');
const preferenceService = globalContext.requireDefault('component/preference/service/index');

const permissions = appConfig.get('Permissions');
const enableGridFlexLayout = _.result(permissions.dynamic, 'GridFlexLayout', false);
const jsdataRawDataPlugin = commonJsdataRawDataPlugin({
  getRawData: _.property('raw'),
  rawDataAccessor(ds) {
    // eslint-disable-next-line no-underscore-dangle
    return ds._rawData || ds.dataSource.dfmRawData;
  },
});

export function getAdsPlugins({
  view,
  filterService,
  scope,
  addDateChangeListener,
  p$daterange,
  router,
  isForVNext,
  adsTabPerfMarker,
  newI18n,
  currentEntity,
  CampaignAdgroupSelectorEdmView,
  PredicateListReact,
  deps,
  preexecuteFlag = false,
  serverContext,
}) {
  const ReportEmailRule = appState.get('$ReportEmailRule');
  appState.unset('$ReportEmailRule');

  const columnChooserConfig = getColumnChooserConfig({
    scope,
    isForVNext,
    deps,
    filterService,
    permissions,
  });

  if (isForVNext) {
    columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';
  }

  const currentCampaign = appConfig.get('CurrentCampaign');
  const isAudienceFeedBasedCampaignLevel =
    currentCampaign &&
    currentCampaign.CampaignType === 8 && // 8 is responsiveAdType
    _.result(_.first(currentCampaign.CampaignSettings), 'ProviderId');

  const enableEdit =
    !isAudienceFeedBasedCampaignLevel && !appConfig.get('CurrentAccountInActive') && !permissions.IsReadOnlyUser;

  const bulkEditPlugin = adsBulkEdit({
    instrumentation,
    status: adsStatus,
    ChangeStatusView,
    ChangeStatusModel,
    filterService,
    scope,
    ChangeAdsView,
    ChangeAdsModel,
    ChangeUrlOptionsView,
    ChangeUrlOptionsModel,
    ChangeThirdPartyMeasurementView,
    ChangeThirdPartyMeasurementModel,
    ChangeThirdPartyMeasurementViewV2,
    RequestExceptionCallBack: view.RequestExceptionCallBack.bind(view),
    MMABulkConversion: view.MMABulkConversion.bind(view),
    CopyPaste,
    config: appConfig,
    i18n,
    newI18n,
    isForVNext,
    perfMarker: adsTabPerfMarker,
    serverContext,
  });
  const aggregatedRowsPlugin = aggregatedRowsPluginBuilder({
    i18n,
    keys: {
      overallI18nKey: 'AdsSummary_Total_New',
      filteredI18nKey: 'AdsSummary_Filtered_Total_New',
      waterfallFilterI18nKey: 'AdsSummary_Quickfilter_Total_New',
    },
    permissions,
    filterService,
    customConfig: {
      showLinkedInRow: true,
    },
  });

  return _.compact([{
    // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
    plugin: perfMarkerPlugin,
    config: { appConfig, marker: adsTabPerfMarker },
  }, {
    plugin: aggregatedRowsPlugin,
  }, !isAudienceFeedBasedCampaignLevel && {
    plugin: automatedRulesPlugin,
    config: {
      isForVNext,
      entityName: 'Ad',
      i18n,
      router,
      instrumentation,
      currentUserId: appConfig.get('CurrentUser').Id,
      permissions,
      scope,
      accountTimeZone: appConfig.get('AccountTimeZone'),
      accountCurrencyCode: appConfig.get('AccountCurrencyCode'),
      state: appState,
      odata,
      stateMgr: stateManager,
      preferenceSvc: preferenceService,
      appCfg: appConfig,
      newI18n,
      CampaignAdgroupSelectorEdmView,
      currentEntity,
      PredicateListReact,
    },
  }, {
    plugin: assistedSelectionPlugin,
  }, {
    plugin: a11yPlugin,
    config: { i18n },
  }, {
    plugin: bulkEditPlugin,
  }, {
    plugin: columnChooserPlugin,
    config: columnChooserConfig,
  }, {
    plugin: dateFilterPlugin,
    config: {
      state: appState,
      isOdataActionSource: true,
      edm: preexecuteFlag ? mockEdm.default : edm,
      addDateChangeListener,
      comparisonColumns: [
        'PeriodPerformanceMetrics',
        'PerformanceMetricsChange',
        'PerformanceMetricsChangePercentage',
      ],
      p$daterange,
    },
  }, enableEdit && {
    plugin: editablePlugin,
    config: { i18n },
  }, {
    plugin: inlineDownloadWithoutFilterstatePlugin,
    config: {
      isForVNext,
      p$daterange,

      DownloadView,
      isAvailable: true,
      schema: Ad,
      gridId: 'AdGrid',
      i18n,
      s$i18n,
      ReportEmailRule,
      processReportRule: (ReportRule) => {
        ReportRule.Headers.push('AdStrength Action Items');
        return _.defaults({
          Selection: _.defaults({
            AdId: Number(scope.adId),
            QueryString: `${ReportRule.Selection.QueryString}${',AdStrengthActionItems'}`,
          }, ReportRule.Selection),
        }, ReportRule);
      },
    },
  }, {
    plugin: inlineErrorPlugin({
      errorIconClasses: ['grid-error'],
    }),
  }, {
    plugin: labelsPlugin,
    config: {
      isForVNext,
      router,
      i18n,
      i18nErrors,
      jsdata,
      LabelAssociationView,
      dataContextManager,
      cacheService,
      instrumentation,
      s$label: Label,
      scope,
      edm: preexecuteFlag ? mockEdm.default : edm,
      perfMarker: adsTabPerfMarker,
    },
  }, {
    plugin: jsdataRawDataPlugin,
  }, {
    plugin: performanceLogPlugin,
    config: { appConfig, logger },
  }, {
    plugin: periodOverPeriodPlugin,
    config: { i18n },
  }, {
    plugin: paginationPlugin,
    config: {
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageNumberLabelText: isForVNext ? '' : i18n.getString('Grid_Page_Number_Label_Text'),
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
      resetPageNumberOnSort: true,
    },
  }, {
    plugin: segmentPlugin,
    config: {
      i18n,
      permissions,
      state: appState,
      isOdataActionSource: true,
      edm: preexecuteFlag ? mockEdm.default : edm,
      setSegType,
      getSegType,
      cultureShortDatePattern: appConfig.get('CultureDateTimeFormat').ShortDatePattern,
      cellTemplates: {
        AdPreview: 'default',
      },
    },
  }, {
    plugin: uiBlockerPlugin,
    config: { el: $(isForVNext ? '.ads-page' : '#child-page') },
  },
  ...enableGridFlexLayout ? [{
    plugin: projectionGridFlexColumnResize,
    config: {
      gridName: getGridName('Ad'),
      softDependencies: ['popColumns'],
      preferenceService,
    },
  }] : [getPGridColumnResizePlugin({
    gridName: getGridName('Ad'),
    preferenceService,
    permissions,
  })],
  ]);
}
